// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"102f16d2","977":"6bfff2dd"}[chunkId] + ".chunk.js";
};